import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

@Injectable()
export class MailInMemoryService {

  constructor() { }

  userMailSubscribe(): Observable<Boolean> {
    return of(null);
  }

  userMailUnsubscribe(): Observable<Boolean> {
    return of(null);
  }

  isHashValid(mailHash: string): Observable<Boolean> {
    return of(null);
  }

  hashAction(mailHash: string, subscribe: boolean): Observable<Boolean> {
    return of(null);
  }

}
